const routes = [
  {
    index: true,
    label: "Deen Mohammad Abdullah",
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Publications',
    path: '/publications',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
